import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'booleanToTextKey' })
export class BooleanToTextKeyPipe implements PipeTransform {
  transform(value: boolean | undefined) {
    return value ? 'global.ui.yes' : 'global.ui.no';
  }
}
